import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/189/components/features/cases/OldComponents/cases/skolkovo-kids/index.js");
